
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import { Component } from 'vue-property-decorator';
import Snackbar from '@/store/modules/snackbar';

const trscModule = getModule(Transcription, store);
const snackbarModule = getModule(Snackbar, store);
@Component
export default class TrscOcr extends Vue {
  get html() {
    if (!trscModule.currentTranscription.translation)
      return 'この画像の現代語訳はありません。';
    const notice =
      '<p style="color: red;">【実験中】この現代語訳はAIにより自動生成されたものです。不正確な翻訳やハルシネーション（AIが生成する事実に基づかない情報）の可能性に留意して、読解の参考にしてください。<br>現代語訳の品質についての感想を<a target="_blank" href="https://x.com/intent/post?hashtags=%E3%81%BF%E3%82%93%E3%81%AA%E3%81%A7%E7%BF%BB%E5%88%BB">X（Twitter）</a>やメール等でお知らせください。</p>';
    const text = trscModule.currentTranscription.translation;
    const notes = trscModule.currentTranscription.notes || '';
    const notesTag = `<p style="color: blue;">${notes.replaceAll(
      '\n',
      '<br>',
    )}</p>`;
    return (
      notice +
      "<p class='ocr-text'>" +
      text.replaceAll('\n', '<br>') +
      '</p>' +
      notesTag
    );
  }
}
